module.exports = __webpack_public_path__ + "assets/img/config-table-e47797f9.png";